export const ru = {
    'add-turbo': 'Добавить турбо-страницу',
    'different-turbo': 'Разные турбо-страницы',
    edit: 'Изменить',
    'edit-all': 'Изменить все',
    turbo: 'Турбо-страница'
};
